import { render, staticRenderFns } from "./settlement-sales-summary.vue?vue&type=template&id=2268799c&scoped=true"
import script from "./settlement-sales-summary.vue?vue&type=script&lang=js"
export * from "./settlement-sales-summary.vue?vue&type=script&lang=js"
import style0 from "./settlement-sales-summary.vue?vue&type=style&index=0&id=2268799c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268799c",
  null
  
)

export default component.exports